var site = site || {};
site.product = site.product || {};
site.product.view = site.product.view || {};

site.product.view.full = function (args) {
  $('.product-full__quantity').selectBoxDefault('selectDefault');
  $('.spp-product__mini-bag-quantity').selectBoxDefault('selectDefault');
  $('.product-full__price-size-select').selectBoxDefault('selectDefault');
  var that = {
    productData : args.productData,
    productId : args.productData.PRODUCT_ID,
    productCode : args.productData.skus[0].PRODUCT_CODE
  };
  var productName = that.productData.SUB_LINE;
  var productSubname = that.productData.PROD_RGN_SUBHEADING;
  var product_images = that.productData.XL_IMAGE;

  if (!args.productData) return null;

  var $productImages = $('.product-full__images');
  $productImage = $('img',$productImages);
  $productImageCount = $productImage.length;

  var isEsteeEdit = $('.product-full').hasClass('product-full--estee-edit');
  var isSPPage = $('.product-full').length > 0;
  var isSPPVideo = 0;
  var colorBoxClassName = isEsteeEdit ? 'colorbox__estee-edit' : 'colorbox__youtube';
  var esteeEditVideo;
  var $videoImageContainer;

  // add video
  if (isEsteeEdit || isSPPage) {
    esteeEditVideo = 0;

    try {
      esteeEditVideo = args.productData.VIDEO_FILE[0];
      isSPPVideo = args.productData.VIDEO_FILE[0];
    } catch (e) { /*empty*/ }

    if (esteeEditVideo) {
      var videoPath = '/media/export/cms/products/558x768/';
      var videoPathImage = 'el_video_' + args.productData.PRODUCT_ID + '_558x768_0.jpg';
      videoPath = videoPath + videoPathImage;

      var $videoLink = $('<a/>', {
        class: 'video-launcher',
        href: '//www.youtube.com/embed/' + esteeEditVideo + '?autoplay=1&rel=0',
        html: '<img src="' + videoPath + '" alt="' + productName + '" />'
      });

      $videoImageContainer = $('<div/>', {
        class: 'product-full__image product-full__video js-prod-level-video',
        html: $videoLink
      }).attr('data-thumb', videoPath).attr('data-video', esteeEditVideo);

      $productImages.append($videoImageContainer);
      $('.video-launcher').colorbox({iframe: true, width: '100%', height: '100%', className: colorBoxClassName});
    }
  }
  var slickToggleTimer1;
  var slickToggleTimer2;

  var startSlider = function() {
    function slickToggle(){
      slickToggleTimer1 = setTimeout(function(){
        $('.product-full__images').slick('slickNext');
        slickToggleTimer2 = setTimeout(function(){
          $('.product-full__images').slick('slickPrev');
        },3000);
      },3000);
    }
    if($('.product-full__images').hasClass('slick-slider')){
      $('.product-full__images').slick('unslick');
    }
    $('.product-full__images').slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      onInit: function(args){
        var slideLength = args.$slides.length;
        if(slideLength >= 2){
          slickToggle();
        }
      },
      customPaging: function(slider, i) {
        var thumb = $(slider.$slides[i]).find('img').attr('src');
        return $('<div/>')
          .addClass('product-full__image__thumb')
          .css({ backgroundImage: 'url(' + thumb + ')'})
          .get(0).outerHTML; // return an html string instead of an object
      },
    });

    // get SKU Base ID from url and change shade based on that
    var skuBaseIDfromURL = window.location.hash.substr(1);
    if (skuBaseIDfromURL.length > 1 && typeof skuBaseIDfromURL === 'number') {
      var skuDataFromURL = _.find(that.productData.skus, function(sku){ return sku.SKU_BASE_ID == skuBaseIDfromURL; });
      // PHF 20150924 i244689: Special for Foundation Kit page
      if ( skuDataFromURL.PRODUCT_ID === "PROD38032" ) {
        $('.product-full__price-size-select option[data-sku-base-id="'+ skuBaseIDfromURL +'"]').prop("selected",true);
        $('button.js-add-to-cart').attr('data-sku-base-id',skuBaseIDfromURL);
        var dataSkuBaseIdList = $('select.product-full__price-size-select option').map(function(){return $(this).attr('data-sku-base-id');}).get();
        for (var i in dataSkuBaseIdList) {
            if ( dataSkuBaseIdList[i] !== skuBaseIDfromURL ) {
                    $('option[data-sku-base-id="'+ dataSkuBaseIdList[i] +'"]').prop("disabled",true)
            }
        }
      }
      $productImages.trigger('sku:select', skuDataFromURL);
      sppPicker.updateSwatches(skuBaseIDfromURL);
      sppPicker.updateSelects(skuBaseIDfromURL);
    }
  };

  $productImage.each(function(index, val) {
    var smooshCheck = $(this).attr('src').indexOf('smoosh');
    if(smooshCheck > 1) {
      $(this).parent().addClass('smoosh');
    }
  });

  startSlider();


  $productImages.on('sku:select', function(e, skuData) {
    window.clearTimeout(slickToggleTimer1);
    window.clearTimeout(slickToggleTimer2);
    //update main images
    var newImageArray = [];
    newImageArray = skuData.XL_IMAGE;
    var newSmoosh = skuData.XL_SMOOSH;
    var startAtSmoosh = false;

    if (that.productData.shaded && newSmoosh.length) {
      var currentSlide = $('.product-full__images').slick('slickCurrentSlide');
      if ($('.product-full__image').eq(currentSlide).hasClass('smoosh')) {
        startAtSmoosh = true;
      }
      newImageArray.splice(1, 0, newSmoosh);
    }

    // To push product level images into images array
    if (!_.isUndefined(product_images)) {
      if (!_.isNull(product_images) && product_images.length > 0) {
        newImageArray = newImageArray.concat(product_images);
      }
    }
    //getting odd duplicate, make unique
    newImageArray = _.uniq(newImageArray);
    //remove empty elements from array
    newImageArray = newImageArray.filter(function(v){return v!==''});

    //current slide count
    var slideCount = $('.product-full__images .slick-slide').length;
    //create new list
    for(var i = (slideCount-1); i >= 0; i--){
      $('.product-full__images').slick('slickRemove', i);
    }
    $(newImageArray).each(function(index, val) {
      //add smoosh class
      var smooshClass = val.indexOf('smoosh') > 1 ? 'smoosh' : '';
      //add slide
      var newSlide = '<div class="product-full__image ' + smooshClass + '"><img src="'+ val + '" /></div>'
      $('.product-full__images').slick('slickAdd', newSlide);
    });


    if ((isEsteeEdit || isSPPVideo) && esteeEditVideo) {
      $('.product-full__images').slick('slickAdd', $videoImageContainer);
      $('.video-launcher').colorbox({iframe: true, width: '100%', height: '100%', className: colorBoxClassName});
    }

    if (startAtSmoosh) {
      // Go to the second slide 'smoosh mode'
      $('.product-full__images').slick('slickGoTo', 1);
    }
  });

  // shade filter
  if(that.productData.shaded){
    if (!Drupal.settings.globals_variables.enable_deep_link) {
      var sppPicker = new site.ShadePicker(that.productData);
    }
    var $shadeFilterItem = $('.product-full__shade-filter-item');
    var $swatches = $('.swatch','.shade-list');

    $shadeFilterItem.click(function(event) {
      $shadeFilterItem.removeClass('is_selected');
      $(this).addClass('is_selected');
      if($(this).hasClass('all-item')){
        $swatches.parent().show();
        $swatches.first().click();
      }else if($(this).hasClass('intensity-item')){
        var intensity = $(this).attr('data-intensity');
        $swatches.parent().hide();
        var $swatchesFiltered = $swatches.filter("[data-intensity=" + intensity +  "]");
        $swatchesFiltered.parent().show();
        $swatches.first().click();
      }else if($(this).hasClass('misc-flag-item')){
        var miscFlag = $(this).attr('data-misc-flag');
        $swatches.parent().hide();
        $swatches.first().click();
        var $swatchesFiltered = $swatches.filter("[data-misc-flag=" + miscFlag +  "]");
        $swatchesFiltered.parent().show();
      }
    });
  }

  site.addFavoritesButton($(".js-add-to-favorites"));

  var $quantitySelect = $('.product-full__quantity');
  var $sizeSelect = $('.product-full__price-size-select');
  var $skintypeSelect = $('.product-full__skintype-select');

  // set the default skintype value in the dropdown to match the one set in .net
  // note that the size select keys off of the skincare dropdown, so this must be set first
  if($skintypeSelect.length){
    // the default sku
    var defaultSku = args.productData.skus[0].SKU_BASE_ID;

    // get the value for the select with the data-skus attribute matching the default sku
    var defaultSkinTypeValue = $("[data-skus='" + defaultSku + "']").attr('value');

    // if there is also a sizeSelect, there may be a list of skus on the data-skus value, so need to match differently
    if ($sizeSelect.length){
        $skintypeSelect.find('[data-skus]').each( function (index, selectOption){
            if ($(selectOption).attr('data-skus')){
              var skus = $(selectOption).attr('data-skus').split(',');

              $(skus).each(function(index, skuValue){
                if (skuValue == defaultSku){
                  defaultSkinTypeValue = $(selectOption).attr('value');
                }
              });
            }
        });
    }

    // set that as the value of the select
    $(".product-full__skintype-select").val(defaultSkinTypeValue);

    // update the select box
    $skintypeSelect.selectBox('refresh');
  }

  //size select init:

  //get skus to show from skintype
  //if size exists
  if($sizeSelect.length && $skintypeSelect.length){
    function updateSizeSelect(){
      $('option', $sizeSelect).prop('disabled', true);
      var selectedSkus = $skintypeSelect.find('option:selected').attr('data-skus').split(',');
      $(selectedSkus).each(function(index, val) {
        var $option = $('option', $sizeSelect).filter("[data-sku-base-id=" + val +  "]");
        $option.prop('disabled', false);
        if(index == 0){
          $option.prop('selected', true);
        }
      });
      $sizeSelect.trigger('change');
    }
    updateSizeSelect();
  }

  if($sizeSelect.length){
    $sizeSelect.selectBox();
  }

  $sizeSelect.on('change', function() {
    $(this).find('option').each(function(index){
      if($sizeSelect.val() == $(this).val()) {
        if($(this).prop('disabled'))
          $(this).prop('selected', false);
         else
          $(this).prop('selected', true);
      }
    });
    var selectedSku = $(this).find('option:selected').attr('data-sku-base-id');
    var skuData = _.find(that.productData.skus, function(sku){ return sku.SKU_BASE_ID== selectedSku; });
    site.skuSelect(skuData);
  });

  $quantitySelect.change(function(event) {
    var quantity = $(this).val();
    site.qtySelect(that.productId, quantity);
    $('select.spp-product__mini-bag-quantity').val(quantity);
    $('.spp-product__mini-bag-quantity').selectBox('refresh');
  });

  // only use skintype as reference, set sku from size select
  $skintypeSelect.change(function(event) {
    if($sizeSelect.length){
      updateSizeSelect();
      $sizeSelect.selectBox('refresh');
    }else{
      var selectedSku = $(this).find('option:selected').attr('data-skus');
      //console.log(selectedSku);
      var skuData = _.find(that.productData.skus, function(sku){ return sku.SKU_BASE_ID== selectedSku; });
      site.skuSelect(skuData);
    }
  });

  $('.product-full__share').click(function(){
    var url = document.documentURI;
    var title = document.title;
    var img = $('#main img').first().attr("src");

    var twitter_url = 'http://twitter.com/intent/tweet?url=' + encodeURI(url) + '&amp;text=' + encodeURI(title) + '&amp;via=EsteeLauder';
    var facebook_url = 'http://www.facebook.com/sharer.php?u=' + encodeURI(url) + '&amp;t=' + encodeURI(title);

    var pinterest_url = 'http://pinterest.com/pin/create/button/?url=' + encodeURI(url) + '&amp;media=' + encodeURI(window.location.protocol) + '//' + encodeURI(window.location.host) + img + '&amp;description=' + encodeURI(title);

    var socialHTML ='<div class="social-share"><h4 class="title">Share</h4> <ul> <li><a class="social-share__link facebook" href="' + facebook_url + '" target="_blank">Facebook</a></li> <li><a class="social-share__link twitter" href="' + twitter_url + '" target="_blank">Twitter</a></li> <li><a class="social-share__link pinterest" href="' + pinterest_url + '" target="_blank">Pinterest</a></li> </ul> </div> ';
    $.colorbox({
      html: socialHTML,
      className: "colorbox--social-share",
      width: "320px",
      height: "200px"
    });
    return false;
  });

  $('#engraving').change(function(){
    if ($(this).is(":checked")){
        this.content = $('script.inline-template[path="engraving_form"]').html();
        engravingHTML = Mustache.render(this.content, {});
        $.colorbox({
            html: engravingHTML,
            width: "700px",
            height: "500px",
            className: "colorbox--engraving",
            onComplete: initEngravingForm
        })
    }
  })

  // Add share icons
  //updateSocialLinks();
  var getShortUrl = function (urlIn, callback) {
      // clean up urlIn
      urlIn = urlIn.replace(/#.*/,"");

      // add swatch info
      var skuBaseId = $('.swatch--selected.selected').attr('data-sku-base-id');
      if ( skuBaseId ) {
          urlIn += "#"+ skuBaseId;
      }

      //var accessToken = '76cd85b016e8bd7a08db6ed187302c4ad8da70f2';
      var accessToken = 'f59213cc485198f3cba5dbc55e75bd6891f77ece';
      var apiUrl = 'https://api-ssl.bitly.com/v3/shorten?access_token=' + accessToken + '&longUrl=' + encodeURIComponent(urlIn);

      $.getJSON(
      apiUrl,
      {},
      function(response)
      {
          if(callback) {
              callback(response.data.url);
          }
      }
      );

  };

  var openSocialMedia = function(newUrl) {
      var deviceAgent = navigator.userAgent;
      var ios = deviceAgent.toLowerCase().match(/(iphone|ipod|ipad)/);
      var win;
      if (ios) {
          window.location=newUrl;
      } else {
          win = window.open(newUrl, '_blank');
          if (win) {
              win.focus();
          }
      }
  }

  var applySocialMediaOffer = function(offerCode) {
    var signedIn = site.userInfoCookie.getValue('signed_in')
    var isLoyaltyMember = site.userInfoCookie.getValue('is_loyalty_member');

    // if the user is signed in and a loyalty member apply the social media offer
    if(signedIn && isLoyaltyMember) {
      var paramObj = {'offer_code' : offerCode, 'do_not_defer_messages' : 1};

      generic.jsonrpc.fetch({
        method: 'offers.apply',
        params: [paramObj]
      });
    }
  }

  if ($('.product-full__personal').find('.social-share-icons').length > 0) {

    var url = document.documentURI;
    var title = document.title;
    var shareCopyLine1 = "What's happening?";
    var shareCopyLine2 = "Check out " + productName + " from @Esteelauder";
    var img = $('#main img').first().attr("src");
    var subjectLine = "Check out " + productName + " from Estée Lauder";
    var email = 'mailto:?to=%20&body=I thought you might like this product from Estée Lauder!' + encodeURI(url) + '&subject=' + encodeURI(subjectLine);
    var twitter_url = 'http://twitter.com/intent/tweet?url=' + encodeURI(url) + '&amp;text=' + encodeURI(shareCopyLine1) + '%0A' + encodeURI(shareCopyLine2);
    var facebook_url = 'http://www.facebook.com/sharer.php?u=' + encodeURI(url) + '&amp;t=' + encodeURI(shareCopyLine1) + '%0A' + encodeURI(shareCopyLine2);
    var pinterest_url = 'http://pinterest.com/pin/create/button/?url=' + encodeURI(url) + '&amp;media=' + encodeURI(window.location.protocol) + '//' + encodeURI(window.location.host) + img + '&amp;description=' + encodeURI(shareCopyLine1) + '%0A' + encodeURI(shareCopyLine2);
    $('.product-full__personal .social-share-icons .email').attr('href', email);
    $('.product-full__personal .social-share-icons .facebook').attr('href', facebook_url).attr('offer_code', 'lyl_social_fb');
    $('.product-full__personal .social-share-icons .twitter').attr('href', twitter_url).attr('offer_code', 'lyl_social_twitter');
    $('.product-full__personal .social-share-icons .pinterest').attr('href', pinterest_url).attr('offer_code', 'lyl_social_pinterest');

    // the email icon isn't present, so I didn't actually get to test this part:
    $('.product-full__personal .social-share-icons .email').on("click tap", function(e){
      e.preventDefault();
      getShortUrl( document.location.href, function(result) {
        var url = result;
        var subjectLine = "Check out " + productName + " from Estée Lauder";
        var body = 'I thought you might like this product from Estée Lauder!';
        var email = 'mailto:?to=%20&body=' + encodeURI(body) + encodeURI(url) + '&subject=' + encodeURI(subjectLine);
        openSocialMedia(email);
      });
    });

    // pinterest
    $('.product-full__personal .social-share-icons .pinterest').on("click tap", function(e){
      e.preventDefault();
      getShortUrl( document.location.href, function(result) {
        var url = result;
        var img = $('#main img').first().attr("src");
        var shadeName = $('.shade-select .selectBox-label :first').text();
        var shareCopyLine1 = productName + "｜エスティ ローダー公式オンライン ショップ";
        var pinterest_url = 'http://pinterest.com/pin/create/button/?url=' + encodeURI(url) + '&amp;media=' + encodeURI(window.location.protocol) + '//' + encodeURI(window.location.host) + img + '&amp;description=' + encodeURI(shareCopyLine1);
        openSocialMedia(pinterest_url);
      });
      applySocialMediaOffer($(this).attr('offer_code'));
    });

    // facebook
    $('.product-full__personal .social-share-icons .facebook').on("click tap", function(e){
      e.preventDefault();
      getShortUrl( document.location.href, function(result) {
        var url = result;
        var shadeName = $('.shade-select .selectBox-label :first').text();
        var shareCopyLine1 = "What's happening?";
        var shareCopyLine2 = "Check out " + productName + " " + productSubname + (shadeName ? " in " + shadeName : " ") + " from @Esteelauder";
        var facebook_url = 'http://www.facebook.com/sharer.php?u=' + encodeURI(url) + '&amp;t=' + encodeURI(shareCopyLine1) + '%0A' + encodeURI(shareCopyLine2);
        openSocialMedia(facebook_url);
      });
      applySocialMediaOffer($(this).attr('offer_code'));
    });

    // twitter
    $('.product-full__personal .social-share-icons .twitter').on("click tap", function(e){
      e.preventDefault();
      getShortUrl( document.location.href, function(result) {
        var url = result;
        var shadeName = $('.shade-select .selectBox-label :first').text();
        var shareCopyLine1 = productName + "｜エスティ ローダー公式オンライン ショップ";
        var twitter_url = 'http://twitter.com/intent/tweet?url=' + encodeURI(url) + '&amp;text=' + '%0A' + encodeURI(shareCopyLine1);
        openSocialMedia(twitter_url);
      });
      applySocialMediaOffer($(this).attr('offer_code'));
    });

  }

  return that;
};
